<template>
    <div v-if="metrics.length">
        <div class="slot-lab">До старта — диагностика</div>
        <p class="diag-sub">Три ключевых показателя из Доктор DH. С чего стоит начать.</p>
        <div class="dr-grid">
            <div v-for="metric in metrics" :key="metric.title" :class="['dr-card', metric.status]">
                <div class="dr-head">
                    <div class="dr-title">{{ metric.title }}</div>
                    <div :class="['dr-badge', metric.status]">
                        <v-icon size="14" color="white">{{ doctorMetricIcon(metric.status) }}</v-icon>
                    </div>
                </div>
                <div class="dr-metric">
                    <div>
                        <div class="dr-col-lab">Ваше значение</div>
                        <div :class="['dr-val', metric.status]">{{ metric.value }}</div>
                    </div>
                    <div>
                        <div class="dr-col-lab">Эталон</div>
                        <div class="dr-std">{{ metric.standard }}</div>
                    </div>
                </div>
                <div :class="['dr-note', metric.status]">{{ metric.note }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { doctorMetricIcon } from '../utils/scenarioUi'

export default {
    name: 'StarterPackDoctorMetrics',
    props: {
        metrics: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        doctorMetricIcon,
    },
}
</script>

<style lang="scss" scoped>
@import '@/vars.sass';

.slot-lab {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 14px;
    color: $muted-light-new;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.09em;
    text-transform: uppercase;
}

.slot-lab::after {
    flex: 1;
    height: 1px;
    background: $border-new;
    content: '';
}

.diag-sub {
    margin: -6px 0 14px;
    color: $muted-new;
    font-size: 12.5px;
    line-height: 1.5;
}

.dr-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
    margin-bottom: 36px;
}

.dr-card {
    position: relative;
    padding: 17px 18px 16px;
    background: #fff;
    border: 1px solid $border-new;
    border-radius: 13px;
}

.dr-card.good {
    border-top: 3px solid #1fbf63;
}

.dr-card.bad {
    border-top: 3px solid #f0353b;
}

.dr-card.warn {
    border-top: 3px solid #f2a615;
}

.dr-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 15px;
}

.dr-title {
    min-width: 0;
    color: $dark-new;
    font-family: Geologica, Inter, system-ui, sans-serif;
    font-size: 14.5px;
    font-weight: 700;
}

.dr-badge {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    border-radius: 50%;
}

.dr-badge.good {
    background: #1fbf63;
}

.dr-badge.bad {
    background: #f0353b;
}

.dr-badge.warn {
    background: #f2a615;
}

.dr-badge ::v-deep .v-icon {
    color: #fff !important;
}

.dr-metric {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 18px;
    margin-bottom: 11px;
}

.dr-metric > div {
    min-width: 0;
}

.dr-col-lab {
    margin-bottom: 5px;
    color: $muted-light-new;
    font-size: 11px;
    white-space: nowrap;
}

.dr-val,
.dr-std {
    font-family: Geologica, Inter, system-ui, sans-serif;
    line-height: 1;
    white-space: nowrap;
}

.dr-val {
    font-size: 23px;
    font-weight: 900;
}

.dr-val.good,
.dr-note.good {
    color: #16a957;
}

.dr-val.bad,
.dr-note.bad {
    color: #e0353b;
}

.dr-val.warn,
.dr-note.warn {
    color: #c77f00;
}

.dr-std {
    color: #9aa2b2;
    font-size: 21px;
    font-weight: 700;
}

.dr-note {
    font-size: 12px;
    line-height: 1.45;
}

@media (max-width: 1024px) {
    .dr-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .dr-val {
        font-size: 20px;
    }

    .dr-std {
        font-size: 18px;
    }
}

@media (max-width: 760px) {
    .dr-grid {
        grid-template-columns: 1fr;
    }

    .dr-val {
        font-size: 18px;
        white-space: normal;
    }

    .dr-std {
        font-size: 16px;
        white-space: normal;
    }
}
</style>
